"use client";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/utils/axios";

export const fetchTopHospitals = createAsyncThunk(
  "topHospitals/fetchTopHospitals",
  async (params = {}) => {
    const {
      locale = "en",
      filters = {},
      pagination = { page: 1, pageSize: 50 }, // Increased pageSize to load all hospitals at once
    } = params;
    const queryParams = new URLSearchParams();

    // Add base params
    queryParams.append("populate", "img");
    queryParams.append("locale", locale);

    // Add pagination in Strapi format
    queryParams.append("pagination[page]", pagination.page);
    queryParams.append("pagination[pageSize]", pagination.pageSize);

    // Add filters if they exist
    if (filters.country) {
      queryParams.append("filters[country][$containsi]", filters.country);
    }

    const queryString = `top-hospitals?${queryParams.toString()}`;
    console.log(queryString)
    const response = await axios.get(queryString);
    console.log(response)
    return response.data;
  
  },
);

const topHospitalsSlice = createSlice({
  name: "topHospitals",
  initialState: {
    hospitals: [],
    status: "idle",
    error: null,
    currentPage: 1,
    hasMore: true,
    totalPages: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopHospitals.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTopHospitals.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Always replace the hospitals array with the new data
        state.hospitals = action.payload.data;
        state.currentPage = action.meta.arg.pagination.page;
        state.totalPages = action.payload.meta.pagination.pageCount;
        // Check if we've reached the end of the list
        const totalHospitals = action.payload.meta?.pagination?.total || 0;
        state.hasMore = state.hospitals.length < totalHospitals;
      })
      .addCase(fetchTopHospitals.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default topHospitalsSlice.reducer;

export const selectAllTopHospitals = (state) => state.top_hospitals.hospitals;
export const selectHospitalsStatus = (state) => state.top_hospitals.status;
export const selectHasMoreHospitals = (state) => state.top_hospitals.hasMore;
export const selectCurrentPage = (state) => state.top_hospitals.currentPage;
